function postsToRemove(hasLargePost, currentRows) {
  if (!hasLargePost) {
    return 0
  }
  return currentRows === 1 ? 1 : 3
}

function getRenderedPostsCount(columns, settings, postsToRenderCount) {
  const hasLargePost = !settings.sameSizePosts && columns > 2
  const largePost = hasLargePost ? 3 : 0

  // display at least one row
  let currentRows = Math.floor((postsToRenderCount + largePost) / columns)
  currentRows = Math.max(1, currentRows)

  const renderedPostsCount = Math.min(
    postsToRenderCount,
    currentRows * columns - postsToRemove(hasLargePost, currentRows),
  )
  return renderedPostsCount
}

export default getRenderedPostsCount
